import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
interface SlideWrapperProps {
  children: ReactNode;
  className?: string;
  showLogo?: boolean;
  variant?: 'light' | 'dark';
}
export function SlideWrapper({
  children,
  className = '',
  showLogo = true,
  variant = 'light'
}: SlideWrapperProps) {
  const bgClass = variant === 'dark' ? 'bg-bg-dark text-white' : 'bg-bg text-text';
  return <div className={`w-full h-full flex flex-col relative overflow-hidden px-8 md:px-16 py-12 ${bgClass} ${className}`} data-id="element-327" data-mp="6fx1vmo8o22v">
      {/* Background Elements */}
      {variant === 'dark' && <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-10" data-id="element-328" data-mp="3sl23z38zwjc8">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] border border-accent rounded-full translate-x-1/3 -translate-y-1/3" data-id="element-329" data-mp="1er6fh3720pn" />
          <div className="absolute bottom-0 left-0 w-[800px] h-[800px] border border-white/20 rounded-full -translate-x-1/3 translate-y-1/3" data-id="element-330" data-mp="2h918l5hmlwni" />
        </div>}

      {/* Header / Logo Area */}
      {showLogo && <motion.div className="absolute top-8 left-8 md:left-16 z-10" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} data-id="element-331" data-mp="96ycvpcj0zc3">
          <Logo variant={variant === 'dark' ? 'light' : 'dark'} size="sm" data-id="element-332" data-mp="x4x9edczd5u7" />
        </motion.div>}

      {/* Main Content */}
      <div className="flex-1 w-full max-w-7xl mx-auto flex flex-col justify-center relative z-0" data-id="element-333" data-mp="s4rg6sr2bba0">
        {children}
      </div>
    </div>;
}